export default [
  {
    icon: 'dashboard',
    name: 'Pedidos',
    code: 'orders',
    path: '/dashboard/orders',
    subitems: [],
  },
  {
    icon: 'editor',
    name: 'Cardápio',
    path: null,
    subitems: [
      { name: 'Produtos', path: '/dashboard/products', code: 'products-menu' },
      { name: 'Organização', path: '/dashboard/menu-organization', code: 'organization-menu' },
    ],
  },
  {
    icon: 'table',
    name: 'Mesas',
    path: null,
    subitems: [
      { name: 'Cadastro', path: '/dashboard/tables', code: 'tables' },
      { name: 'Configurações', path: '/dashboard/tables/configuration/editor', code: 'tables' },
    ],
  },
  {
    icon: 'star',
    name: 'Avaliações dos clientes',
    path: '/dashboard/clients-assessments',
    code: 'assessment-config',
    subitems: [],
  },
  {
    icon: 'settings',
    name: 'Configurações',
    path: null,
    subitems: [
      { name: 'Usuário', path: '/dashboard/users', code: 'user-config' },
      { name: 'Perfil', path: '/dashboard/profiles', code: 'profile-config' },
      { name: 'Dúvidas frequentes', path: '/dashboard/doubts', code: 'doubts-config' },
      { name: 'Avaliações de pedidos', path: '/dashboard/assessments', code: 'assessment-config' },
      { name: 'Opções chamar garçom', path: '/dashboard/call-waiter', code: 'call-waiter-config' },
      { name: 'Logo estabelecimento', path: '/dashboard/logo-establishment', code: 'user-config' },
    ],
  },
  {
    icon: 'finance',
    name: 'Financeiro',
    path: null,
    subitems: [
      { name: 'Presencial', path: '/dashboard/finance/presencial', code: 'user-config' },
      { name: 'Configurar Cupom', path: '/dashboard/finance/config-nfce', code: 'user-config' },
    ],
  },
]
